import useUpdatePoolTaskSubmissions from '../../../../hooks/useUpdatePoolTaskSubmissions'
import TaskAllocationAmount from '../../../../shared_components/Missions/TaskAllocationAmount'
import SharedOnChainTask, {
  Props,
} from '../../../../shared_components/Missions/Types/OnChain'

export default function OnChainTask(
  props: Omit<Props, 'updateTaskSubmissions' | 'taskAmount'>,
) {
  const updateTaskSubmissions = useUpdatePoolTaskSubmissions()
  return (
    <SharedOnChainTask
      {...props}
      updateTaskSubmissions={updateTaskSubmissions}
      taskAmount={<TaskAllocationAmount taskId={props.taskId} />}
    />
  )
}
